import { useEffect } from 'react';

const useResizable = (ref, resizerRef, width, setWidth, min = 250, max = 600) => {
    useEffect(() => {
        const resizer = resizerRef.current;
        if (!resizer) return;

        let startX = 0;
        let startWidth = 0;

        const onMouseDown = (e) => {
            startX = e.clientX;
            startWidth = width;
            document.body.style.userSelect = 'none';
            document.body.style.cursor = 'col-resize';
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        };

        const onMouseMove = (e) => {
            const dx = startX - e.clientX;
            const newWidth = Math.min(Math.max(startWidth + dx, min), max);
            setWidth(newWidth);
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
        };

        resizer.addEventListener('mousedown', onMouseDown);
        return () => {
            resizer.removeEventListener('mousedown', onMouseDown);
        };
    }, [resizerRef, width, setWidth, min, max]);
};

export default useResizable;
